// extracted by mini-css-extract-plugin
export default {"background":"lsJ1Z","circle":"Li3rf","skeleton":"UhM1w","firstTitle":"aMSIM","title":"XtEZK","star":"eRi2r","roundStar":"uTXBC","loupe":"R1lk8"};